import { render } from "./PodcastEpisodeCardSkeleton.vue?vue&type=template&id=740838fe&scoped=true"
const script = {}

import "./PodcastEpisodeCardSkeleton.vue?vue&type=style&index=0&id=740838fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740838fe"]])

export default __exports__